import React, { useState, useEffect } from "react";
import Splide from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';
import "../../styles/carousel.css";
import "@splidejs/react-splide/css";
import * as styles from "./Carousel.module.css";

const Carousel = ({ page = "", items, version2, caseStudy, type = "fade", interval = 9000, rewind = true, speed = 750, arrows = true }) => {
  const [currentSlide, setSlide] = useState(0);
  const [slideRate, setSlideRate] = useState(0);

  useEffect(() => {
    const splide = new Splide('.splide', {
      type,
      rewind: true,
      pagination: false,
      infinite: true,
      speed,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows,
      autoHeight: true,
      autoplay: 'pause',
      intersection: {
        inView: {
          autoplay: true,
        },
      },
      interval,
      pauseOnHover: false
    });

    splide.mount( { Intersection } );

    splide.on('autoplay:playing', (rate) => {
      setSlideRate(rate);
    });

    splide.on('move', (active) => {
      splide.Components.Autoplay.play();
      setSlide(active);
    });

    // Add click tracking for arrow navigation
    if (arrows) {
      const prevArrow = document.querySelector('.splide__arrow--prev');
      const nextArrow = document.querySelector('.splide__arrow--next');
      
      if (prevArrow) {
        prevArrow.addEventListener('click', () => {
          window.rybbit?.event("Carousel Nav", { direction: "previous", page: page || "Case Study" });
        });
      }
      
      if (nextArrow) {
        nextArrow.addEventListener('click', () => {
          window.rybbit?.event("Carousel Nav", { direction: "next", page: page || "Case Study" });
        });
      }
    }

    // Add correct ARIA attributes for slides
    document.querySelectorAll('.splide__slide').forEach((slide, index) => {
      slide.setAttribute('aria-roledescription', 'slide'); // Keeps screen reader clarity
      slide.setAttribute('aria-label', `Slide ${index + 1} of ${items.length}`);
    });

  }, []);

  return (
    <div className={`splide ${version2 ? `${styles.splideVersion2} splideVersion2` : ""} ${caseStudy ? `${styles.splideCaseStudy} splideCaseStudy` : ""}`} role="region" aria-roledescription="carousel" aria-label="Testimonials carousel">
      <div className="splide__track" aria-live="polite">
        <div className="splide__list">
          {items.map((item, i) => (
            <div className="splide__slide"
                key={`slide${i + 1}`}
                id={`slide${i + 1}`}>
              {item}
            </div>
          ))}
        </div>
      </div>

      {/* Visual-only dots (not clickable) */}
      <div className={styles.dots} aria-hidden="true">
        {items.map((_, i) => (
          <div
            key={`dot${i}`}
            className={`${styles.dot} ${i === currentSlide ? styles.active : ""}`}
          >
            <div style={{ width: i === currentSlide ? `${(slideRate * 30) + 12}px` : "0" }} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
